module.exports = __webpack_public_path__ + "static/img/Drew2inTDs.69f4866.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Drew2inTDs.gif
// module id = C91/
// module chunks = 1